module.exports = __webpack_public_path__ + "static/media/template-hd1.af979935.png";